import { UiColorTheme } from 'src/core/models/theme/ui-color-theme.enum';
import { UiColorThemePreset } from 'src/core/models/theme/ui-color-theme-preset.model';

export const UI_COLOR_THEME_PRESETS: readonly UiColorThemePreset[] = [
  {
    theme: UiColorTheme.Signature,
    rootClass: 'acx-color-theme-signature',
    iconClass: 'bi bi-circle-fill acx-color-theme-swatch-signature',
    localizationKey: 'AgenticCX::Theme:Signature',
  },
  {
    theme: UiColorTheme.Vibrant,
    rootClass: 'acx-color-theme-vibrant',
    iconClass: 'bi bi-circle-fill acx-color-theme-swatch-vibrant',
    localizationKey: 'AgenticCX::Theme:Vibrant',
  },
  {
    theme: UiColorTheme.Minimal,
    rootClass: 'acx-color-theme-minimal',
    iconClass: 'bi bi-circle-fill acx-color-theme-swatch-minimal',
    localizationKey: 'AgenticCX::Theme:Minimal',
  },
];

export const DEFAULT_UI_COLOR_THEME = UiColorTheme.Signature;

export const UI_COLOR_THEME_SETTING_NAME = 'Ui.ColorTheme';
